// test785
(785 && 0);
